<template>
    <div>
        <nav-breadcrumb :menu="[{label: userId ? '查看外勤任务' : '新增外勤任务'}]"/>
        <el-row>
            <el-col>
                <panel label="基本信息">
                    <el-form :model="assignmentForm" :rules="assignmentFormRules" ref="assignmentForm" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg">
                            <el-col :span="24">
                                <el-form-item label="任务类型：" prop="a__assignmentType" :rules="{required: false, message: '任务类型不能为空'}" style="width: 60%">
                                    <el-select v-model="assignmentForm.a__assignmentType" disabled>
                                        <el-option label="房屋尽调" value="fwjd" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="分公司：" prop="a__branchId" :rules="{required: false, message: '分公司不能为空'}" style="width: 60%">
                                    <el-select v-model="assignmentForm.a__branchId" disabled>
                                        <el-option :label="item.label" :value="item.value" v-for="(item,idx) in branchOptions" :key="idx"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="接收人：" prop="a__assigneeId" :rules="{required: false, message: '接收人不能为空'}" style="width: 60%">
                                    <el-select v-model="assignmentForm.a__assigneeId" disabled>
                                        <el-option :label="item.label" :value="item.value" v-for="(item,idx) in branchUserOptions" :key="idx"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="开始时间：" prop="a__frTime" :rules="{required: false, message: '开始时间不能为空'}" style="width: 60%">
                                    <el-date-picker
                                        v-model="assignmentForm.a__frTime"
                                        value-format="yyyy-MM-dd"
                                        type="date"
                                        placeholder="选择日期">
                                        disabled
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="结束时间：" prop="a__toTime" :rules="{required: false, message: '结束时间不能为空'}" style="width: 60%">
                                    <el-date-picker
                                        v-model="assignmentForm.a__toTime"
                                        value-format="yyyy-MM-dd"
                                        type="date"
                                        placeholder="选择日期">
                                        disabled
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="任务内容：" prop="a__description" :rules="{required: false, message: '任务内容不能为空'}" style="width: 60%">
                                    <el-input type="textarea" v-model="assignmentForm.a__description" style="margin-bottom:10px;" disabled></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </panel>
                <panel label="处理结果">
                    <el-form :model="assignmentForm" :rules="assignmentFormRules" ref="assignmentForm" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg">
                            <el-col :span="24">
                                <el-col :span="24">
                                    <el-form-item label="处理备注：" prop="s__remarks" :rules="{required: false, message: '任务内容不能为空'}" style="width: 60%">
                                        <el-input type="textarea" v-model="assignmentForm.s__remarks" style="margin-bottom:10px;" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="附件：">
                                        <files-data-table :files.sync="assignmentForm.attachments"></files-data-table>
                                    </el-form-item>
                                </el-col>
                            </el-col>
                        </el-row>
                    </el-form>
                </panel>
                <div class="tr xzmt">
                    <el-button @click="$router.back()">返回</el-button>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    export default {
        name: "BranchAssignmentView",
        data() {
            return {
                assignmentId:this.$route.query['assignmentId']||'',
                assignmentForm:{},
                assignmentFormRules:{},
                branchOptions:[],
                branchUserOptions:[],
            }
        },
        mounted() {
            if(this.assignmentId){
                this.getData()

            }
            this.getDataBranchOfficeSelect()
        },
        watch:{
          'assignmentForm.a__branchId':function () {
              this.getDataBranchUserSelect()
          }
        },
        methods:{
            getData:function(){
                xhr.getBranchAssignment({
                        'a.assignmentId': this.assignmentId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.assignmentForm = res.data.data
                            }
                        }catch (e) {

                        }
                    })
            },
            getDataBranchOfficeSelect: function () {
                xhr.getDataBranchOfficeSelect(
                    Object.assign({}, {}, {}),
                    res=> {
                        try {
                            this.branchOptions = res.data.data.map(item=>{
                                return {
                                    label: item.bo__branchName,
                                    value:item.bo__branchId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },
            getDataBranchUserSelect: function () {
                xhr.getDataBranchUserSelect(
                    Object.assign({
                        'bo.branchId':this.assignmentForm.a__branchId
                    }, {}, {}),
                    res=> {
                        try {
                            this.branchUserOptions = res.data.data.map(item=>{
                                return {
                                    label: item.du__userCode,
                                    value:item.du__userId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/branchoffice/BranchAssignmentView.vue